import React, { useEffect, useState } from "react"
import useWindowResize from "@/hooks/useWindowResize"
import Dropdown from "@/components/core/SelectDropdown/SelectDropdown"
import styles from "@/components/AccountsLayout/AccountsLayout/index.module.scss"

const AccountsLayout = ({
  i18n,
  title,
  user,
  isAuth,
  logout,
  data,
  redirect,
  ...props
}) => {
  const [width] = useWindowResize()
  const [activeTab, setActive] = useState(props.activeTab ?? 0)
  const [origin, setOrigin] = useState("")
  const [isMobile, setIsMobile] = useState(width <= 1203)

  useEffect(() => {
    setIsMobile(width <= 1023)
  }, [width])

  useEffect(() => {
    setOrigin(window.location.origin)
  }, [])

  const handleChange = index => {
    setActive(index)
    redirect(data[index].url)
  }

  const getEventInfo = (title, index) => {
    title = title?.toLowerCase()
    return JSON.stringify({
      eventAction: `my account:navigation:${title}`,
      eventName: `my account:navigation:${title}`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: title,
      internalLinkPosition: "my account",
      internalLinkType: "my account:navigation",
      internalLinkZoneName: "my account:navigation",
      internalLinkURL:
        title !== "sign out" && data && data[index] && data[index].url
          ? (data[index].url.indexOf("http") === -1 ? origin : "") +
            data[index].url
          : title === "sign out"
          ? origin + "/en"
          : "n/a",
      clickInternalLinks: "true",
    })
  }

  return (
    <div
      className={`${
        styles.accountTabsWrapper
      } kf-react-container row no-gutters account-tabs ${
        props.customClass ? props.customClass : ""
      } ${props?.accountLayoutLoader ? "accountLayoutLoader" : "pl-lg-0"}`}
    >
      <aside className="col-lg-3 account-tabs__nav-wrapper">
        <div className="account-tabs__nav">
          <div
            id="kf-user-name"
            className="account-tabs__message"
          //  tabIndex="0"   // AS-11116
            role="alert"
          >
            {`${i18n.hi} ${user?.firstName ?? ""}`}
          </div>
          {data && (
            <>
              {!isMobile ? (
                <>
                  <div
                    className="account-tabs__list"
                    role="list"
                    aria-label="Menu items navigation"
                  >
                    {data?.map((item, i) => (
                      <div
                        key={i}
                        role="Link"
                        aria-selected
                        aria-label={() => i18n.menuItems(item.title)}
                        tabIndex={!isMobile ? 0 : -1}
                        data-gbh-data-layer={getEventInfo(item.title, i)}
                        className={`account-tabs__list-item gbh-data-layer ${
                          i === activeTab ? "--active" : ""
                        }`}
                        onClick={() => handleChange(i)}
                      >
                        {item.title}
                      </div>
                    ))}
                  </div>
                  <div
                    tabIndex={!isMobile ? 0 : -1}
                    role="button"
                    aria-label={i18n.ariaSignOut}
                    data-gbh-data-layer={getEventInfo("sign out")}
                    className="account-tabs__sign-out gbh-data-layer"
                    onClick={() => logout()}
                  >
                    {i18n.signOut}
                  </div>
                </>
              ) : (
                <div className="account-tabs__dropdown">
                  <Dropdown
                    id="account-tab"
                    data={data?.map(item => item.title)}
                    value={data[activeTab] ? data[activeTab].title : ""}
                    label={i18n.myAccount}
                    onChange={val =>
                      handleChange(data.findIndex(obj => obj.title === val))
                    }
                  />
                </div>
              )}
            </>
          )}
        </div>
      </aside>
      <section className="col-lg-9 account-tabs__wrapper-nav">
        <div className="account-tabs__content">
          {title && <h1 className="account-tabs__title">{title}</h1>}
          {props.children}
        </div>
      </section>
    </div>
  )
}

export default AccountsLayout
